import { FC } from "react"
import { useTranslation } from "next-i18next"
import { styled } from "@mui/material"
import SmartschoolButton from "./SmartschoolButton"
import { useRouter } from "next/router"

const SLogo = styled("span")({
  fontWeight: "bold",
  margin: "0 0.5rem 0 1rem",
  padding: "0 0.25rem",
  fontSize: "2.4rem",
  lineHeight: "2rem",
  border: "1px solid white",
  borderRadius: "4px",
})

const LoginWithSmartschoolButton: FC = () => {
  const { t } = useTranslation("shop")
  const { query } = useRouter()
  const schoolSlug = (query.school as string) ?? ""

  return (
    <SmartschoolButton
      // @ts-ignore
      component="a"
      href={`/api/auth/oauth2?redirectUrl=/${schoolSlug}/login`}
    >
      {t("authSignInWith")} <SLogo>S</SLogo> Smartschool
    </SmartschoolButton>
  )
}

export default LoginWithSmartschoolButton
